import React from 'react';

import { Box, Grid, Button, useTheme, useMediaQuery } from '@mui/material';

import { useCustomNavigate } from 'src/hooks/use-custom-navigate';

import { PATH_TO_CONTACT, PATH_TO_REGULATION } from 'src/config-global';

import Logo from 'src/components/logo';

export const navigationFooterInfo = [
  {
    text: 'Minha conta',
    type: 'redirect',
    url: '/user/profile',
  },
  {
    text: 'Minhas trocas',
    type: 'redirect',
    url: '/benefits',
  },
  {
    text: 'Fale conosco',
    type: 'open',
    url: PATH_TO_CONTACT,
  },
  {
    text: 'Regulamento',
    type: 'open',
    url: '/Regulamento.pdf',
  },
  {
    text: 'Política de privacidade',
    type: 'open',
    url: PATH_TO_REGULATION,
  },
];

export default function MinimalFooter() {
  const theme = useTheme();
  const navigate = useCustomNavigate();
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isDown350 = useMediaQuery('(max-width: 350px)');
  const isDown320 = useMediaQuery('(max-width: 320px)');
  const calcPosition = () => {
    if (isDown320) {
      return 'center';
    }
    if (isDownSm) {
      return 'space-between';
    }
    return 'center';
  };
  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          bgcolor: '#EAEEF5',
          pb: 5,
          pt: 7,
          aspectRatio: '538/65',
          maxHeight: '120px',
        }}
      >
        <Logo
          data-testid="logo"
          customLogo="/logo/logo_cidade_center_norte.png"
          sx={{
            maxWidth: '404px',
            minHeight: '32px',
          }}
          px={4}
        />
      </Box>
      <Grid
        container
        spacing={1.5}
        justifyContent="space-evenly"
        alignItems="center"
        columnGap="40px"
        sx={{
          py: 4,
          px: 2,
          bgcolor: '#EAEEF5',
        }}
      >
        {[
          { logo: 'lar_center.png', sx: { minWidth: '102px', maxHeight: '24px' } },
          { logo: 'shopping_center_norte.png', sx: { minWidth: '140px', maxHeight: '24px' } },
          { logo: 'expo_center_norte.png', sx: { minWidth: '140px', maxHeight: '24px' } },
          { logo: 'instituto_center_norte.png', sx: { minWidth: '160px', maxHeight: '24px' } },
          { logo: 'center_norte_inc.png', sx: { minWidth: '128px', maxHeight: '24px' } },
        ].map((item, index) => (
          <Grid
            item
            xs={isDown350 ? 12 : 4}
            sm={4}
            md={2}
            key={index}
            display="flex"
            justifyContent="center"
          >
            <Box
              component="img"
              src={`/logo/${item.logo}`}
              alt={`logo-${index}`}
              sx={{
                ...item.sx,
                objectFit: 'contain',
                display: 'block',
              }}
            />
          </Grid>
        ))}
      </Grid>
      <Grid
        container
        sx={{
          bgcolor: '#214983',
          alignContent: 'flex-start',
          justifyContent: calcPosition(),
        }}
      >
        {navigationFooterInfo.map((e, idx) => (
          <Grid item py={3} key={idx}>
            <Button
              sx={{ color: 'common.white', fontWeight: 500, fontSize: '16px !important', px: 3 }}
              onClick={() => {
                if (e?.type === 'open') {
                  window.open(e?.url, '_blank');
                } else {
                  navigate(e?.url);
                }
              }}
            >
              {e?.text}
            </Button>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
